import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {CampaignIssues} from 'common/src/modules/campaigns/campaigns.types';

const CAMPAIGN_ISSUES_SLICE_NAME = 'campaignIssuesSlice';

// Initial state for the slice
const campaignIssuesInitialState: CampaignIssues = {
  campaignLogicIssues: [],
  thirdPartyTrackersIssues: [],
  campaignIntegrationIssues: [],
  placementIssues: [],
};

const campaignIssuesSlice = createSlice({
  name: CAMPAIGN_ISSUES_SLICE_NAME,
  initialState: campaignIssuesInitialState,
  reducers: {
    // Action to reset the state to its initial value
    resetIssues: () => campaignIssuesInitialState,

    // Action to set issues directly in the state
    updateIssues: (_state, action: PayloadAction<CampaignIssues>) => {
      return action.payload;
    },
  },
});

// Export actions
const {updateIssues, resetIssues} = campaignIssuesSlice.actions;
export {resetIssues, updateIssues};

// Export the reducer as the default export
export default campaignIssuesSlice.reducer;
